import { createTheme } from '@mui/material/styles'
import RubikRegular from '../assets/fonts/Rubik-Regular.ttf'
import RubikBold from '../assets/fonts/Rubik-Bold.ttf'
import RubikLight from '../assets/fonts/Rubik-Light.ttf'

const customTheme = createTheme({
  mobilePicker: {
    ':focus': {
      borderWidth: '0px'
    },
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderWidth: '0px',
    paddingTop: '10px',
    paddingBottom: '10px',
    fontSize: '14px'
  },
  dropDownPopUp: {
    marginTop: '42px',
    width: '300px',
    height: '625px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    bgcolor: 'background.paper',
    borderRadius: '45px'
  },
  helpufHintPop: {
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    width: '280px',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '8px'
  },
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '24px',
    borderRadius: 3
  },
  modalDeactivateStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 670,
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '24px',
    borderRadius: 3
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },
  overrides: {
    MuiTableCell: {
      root: {
        paddingTop: '0px',
        paddingBottom: '0px'
      },
      head: {
        lineHeight: 'none'
      }
    },
    MuiCssBaseline: {
      /* Try to avoid importants */
      '@global': {
        '.MuiInputBase-input': {
          color: '#333333 !important'
        },
        '.MuiCheckbox-root': {
          color: '#E5E5E5 !important'
        },
        '.MuiCheckbox-colorPrimary.Mui-checked': {
          color: '#47A0F4 !important'
        },
        '.MuiInputAdornment-root': {
          color: '#333333 !important',
          paddingTop: '21px !important',
          paddingBottom: '4px !important'
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '10px'
      }
    }
  },
  palette: {
    primary: {
      light: '#47A0F4',
      main: '#47A0F4',
      dark: '#0072CE',
      contrastText: '#fff',
      text: '#212121'
    }
  },
  shadow: {
    paperBoxShadow:
      '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
    cardDefaultShadow: '6px 9px 43px rgba(216, 216, 216, 0.25)'
  },
  colors: {
    grayDivider: '#D9D9D9',
    gray5: '#DDE2E9',
    black1: '#222222',
    grayAlt: '#858585',
    deleteRed: '#EA5757',
    lightBlue3: '#F1F7FF',
    red0: '#E93750',
    photoCardBackgroundColor: '#465CFF',
    trackDark: '#39393D',
    trackLight: '#E9E9EA',
    darkThemeSwitchTrack: '2ECA45',
    closeIconColor: '#B0B0B0',
    lightBlue2: '#F6F7FF',
    darkRed: '#333',
    loadingRing: '#000000',
    darkBlue: '#374957',
    lightBlue: '#EEFBFE',
    pink: '#FDEEFE',
    buttonPrimary: '#EEEEEE',
    gradient: '#DCDCDC',
    red: '#FF0000',
    gray2: '#F2F2F2',
    gray3: '#F9F9F9',
    gray4: '#929292',
    description: '#6C7172',
    freeFormInputBackground: '#2b2b2b',
    grayBorder: '#B8B8B8',
    maskIcon: '#212121',
    inputBorder: '#d8d8d8',
    textButton: '#828282',
    generalBackground: '#fafafa',
    text: '#333333',
    transparent: 'rgba(0,0,0,0.0)',
    textGray: '#BDBDBD',
    clearAdornment: '#8E8E8E',
    errorText: '#F44337',
    checkDomain: '#8CD38B',
    backdropColor: '#FFFFFF',
    navBarColor: '#FFFFFF',
    highlightButtonText: '#FFFFFF',
    basicButtonBackground: '#FFFFFF',
    basicDisabledButtonBackground: '#E5E5E5',
    basicDisabledButtonColor: '#4f4f4f',
    yellow: '#F2C94C',
    chipVisible: '#C4C4C4',
    chipVisibleOff: '#F1F1F1',
    white: '#FFFFFF',
    gray: '#4F4F4F',
    snackbar: 'hsla(207, 100%, 40%, 0.8)',
    alert: '#47a0f499',
    borderBrowser: '#C3C3C3',
    filtersBorder: '#0000003b',
    complianceBlue: '#E2EBF3',
    iconBlueLight: 'rgba(47, 128, 237, 0.3)',
    iconBlue: '#2F80ED',
    mainBlue: '#0072CE',
    redError: '#EB5757',
    logInDisabledBackground: '#E0E0E0',
    approved: '#27AE60',
    error: '#CE004A',
    borderBlue: 'rgba(47, 128, 237, 0.5)',
    borderRedError: 'rgba(235, 87, 87, 0.5)',
    profile: {
      text_grey: '#212121',
      avatar_bg: '#F9F9F9',
      avatar_icon: '#4F4F4F',
      border_input: '#ced4da',
      border_focus: '#80bdff',
      box_shadow: 'rgba(0,123,255,.25)',
      borders: '#F2F2F2',
      darkCard: '#E0E0E0',
      disabled_bg: '#F5F5F5',
      mapFill: '#AF1199',
      mapStroke: '#FFFFFF'
    },
    signInButton: {
      background: '#F2F2F2',
      label: '#676767'
    },
    dividers: '#EAEBEB',
    tradesBackground: '#F8F8F8',
    mainContainerBackground: '#F8F8F8',
    tab: {
      description: '#121212',
      duedate: '#828282',
      selected: '#2F80ED',
      selectedBlack: '#4F4F4F'
    },
    settings: {
      fieldName: '#828282',
      fieldInfo: '#6C7172',
      decline: '#FA5454',
      button_info: '#BCBCBC',
      disabled: '#E0E0E0',
      border: '#E5E5E5',
      cardBorderColor: 'rgba(216, 216, 216, 0.25)',
      delete: '#FC5E5E',
      disabledButton: '#C4C4C4',
      editButton: '#2F80ED'
    },
    company: {
      title: '#333333',
      inputBorder: '#0000003A',
      roleButton: '#E0E0E018',
      iconColor: '#B0B0B0'
    },
    accountSettings: {
      bgBlue: '#6F7D94'
    },
    workStatusBorder: 'rgba(71,160,244,0.1)',
    infoWindowBackground: '#FBFBFB',
    columnTitle: '#6C7172',
    disabledField: '#E0E0E0',
    stepperGray: '#828282',
    dotsBack: '#E0E0E0',
    dialog: {
      text_grey: '#4F4F4F',
      text_white: 'white',
      ok_button: '#2F80ED',
      hover: '#BDBDBD',
      border: '#E0E0E0'
    }
  },
  typography: {
    fontFamily: '"Rubik"',
    fontWeight: 400,
    fontSize: 18,
    fontStyle: 'normal',
    allVariants: {
      color: '#333333'
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Rubik';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Rubik'), local('Rubik'), url(${RubikRegular}) format('truetype');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'Rubik Bold';
          font-style: bold;
          font-display: swap;
          font-weight: 700;
          src: local('Rubik'), local('Rubik'), url(${RubikBold}) format('truetype');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'Rubik Light';
          font-style: normal;
          font-display: swap;
          src: local('Rubik'), local('Rubik'), url(${RubikLight}) format('truetype');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
      '@global': {
        '.MuiInputBase-input': {
          color: '#333333 !important'
        },
        '.MuiCheckbox-root': {
          color: '#E5E5E5 !important'
        },
        '.MuiCheckbox-colorPrimary.Mui-checked': {
          color: '#47A0F4 !important'
        },
        '.MuiInputAdornment-root': {
          color: '#333333 !important',
          paddingTop: '21px !important',
          paddingBottom: '4px !important'
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '10px'
      }
    }
  },
  filtersClasses: {
    mainInput1: {
      fontSize: '12px',
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      width: 'auto',
      marginLeft: '0px',
      height: '32px',
      border: '1px solid #0000003b',
      display: 'flex',
      text_overflow: 'ellipsis'
    },
    mainInput2: {
      fontSize: '12px',
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      width: 'auto',
      marginLeft: '0px',
      height: '36px',
      border: '1px solid #0000003b',
      display: 'flex',
      text_overflow: 'ellipsis'
    },
    searchInput1: {
      fontSize: '12px',
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      width: 'auto',
      marginLeft: '0px',
      height: '36px',
      border: '0px',
      text_overflow: 'ellipsis'
    },
    searchInput2: {
      fontSize: '12px',
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      width: 'auto',
      marginLeft: '0px',
      height: '32px',
      border: '0px',
      text_overflow: 'ellipsis'
    },
    menuItem: {
      '&.MuiMenuItem-root': {
        fontSize: '14px',
        width: '100%',
        display: 'flex',
        maxWidth: '352px',
        lineHeight: '20px',
        flex: 1
      }
    }
  },
  dashboard: {
    black: '#000000',
    gray: '#4F4F4F',
    disabled: '#6C7172',
    darkBlue: '#0072CE',
    underlineColor: '#333333'
  },
  mapClasses: {
    '& .storemapper-iw-close': {
      display: 'none !important'
    },
    '& .gm-style-iw-c': {
      backgroundColor: '#FBFBFB !important'
    },
    '& .gm-style-iw-c > div': {
      overflow: 'hidden !important'
    },
    '& .gm-style-iw-c > button': {
      display: 'none !important'
    },
    '& .gm-style-iw-t::after': {
      display: 'none !important'
    },
    '& .gm-style-iw > button': {
      display: 'none !important'
    },
    '& .gm-style > img': {
      display: 'none !important'
    },
    '& .infoBox': {
      overflow: 'hidden !important',
      borderRadius: '8px'
    },
    '& .gm-style .gm-style-iw-t::after': {
      display: 'none !important'
    }
  }
})

export default customTheme
